import React, { useState } from 'react';
import DOMPurify from 'dompurify';
import moment from "moment";

const CONF = window?.confPub;
const UI = CONF?.UI?.FORMULAIRES?.CHANGEMENT_COORDONNEES;
const CHANGEMENT_COORDONNEES_INPUTS = UI?.INPUTS;
const ROUTES = CONF.ROUTES;
const PAGES = ROUTES.PAGES;
const REGEX = CONF?.UI?.REGEX;
const PATTERNS = CONF?.PATTERNS

export function renderError(message) {
    return (
        <small className='text-danger pt-3' dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(message)
        }}/>
    )
}

export function validateField(inputName, inputValue) {

    let validInput = true;
    let msgError = "";
    let inputValueTrim = inputValue.trim();

    switch (inputName) {


    case CHANGEMENT_COORDONNEES_INPUTS?.EMAIL?.NAME:

        if (!inputValueTrim) {
            validInput = false;
            msgError = CHANGEMENT_COORDONNEES_INPUTS?.EMAIL?.ERRORS?.MANDATORY;


        } else if (!new RegExp(REGEX?.EMAIL).test(inputValueTrim)) {

            validInput = false;
            msgError = CHANGEMENT_COORDONNEES_INPUTS?.EMAIL?.ERRORS?.INVALID;
        }
    }


    return { validInput, inputValue, inputValueTrim, msgError }
}

export function  checkFields(name, value, isMandatory = true)  {

    const INPUTS = CONF?.UI?.FORMULAIRES?.COMMUN_INPUTS

    let invalid = false

    switch (name) {

        case INPUTS.NOM.NAME:
        case INPUTS.PRENOM.NAME:

            invalid = checkInvalidNom(value, name, isMandatory)

            console.log("invalid inside")
            console.log(invalid)

            break

        case INPUTS?.DATE_NAISSANCE?.NAME:

            invalid = checkInvalidDateNaissance(value, false)

            break

        case INPUTS.NUM_CONTRAT.NAME:

            if (!value) {

                invalid = INPUTS.NUM_CONTRAT.ERRORS.MANDATORY

            } else if (!new RegExp(REGEX.NUMBER).test(value)) {

                invalid = INPUTS.NUM_CONTRAT.ERRORS.ONLY_NUMBERS;

            } else if (!new RegExp(REGEX.NUM_CONTRAT).test(value)) {

                invalid = INPUTS.NUM_CONTRAT.ERRORS.TOO_SHORT;
            }
            break;

        case INPUTS.NUM_AGENT.NAME:

            if (!value) {

                invalid = INPUTS.NUM_AGENT.ERRORS.MANDATORY;

            }
            // TODO voir pour adapter les règles 38942W
            // else if (!new RegExp(REGEX.NUMBER).test(value)) {
            //
            //     valid = false;
            //     msgError = INPUTS.NUM_AGENT.ERRORS.ONLY_NUMBERS;
            //
            // } else if (!new RegExp(REGEX.NUM_AGENT).test(value)) {
            //     valid = false;
            //     msgError = INPUTS.NUM_AGENT.ERRORS.SIZE;
            // }
            break;

        case INPUTS?.ADRESSE?.DEPARTEMENT?.NAME:

            if (!value && isMandatory) {

                invalid = INPUTS?.ADRESSE?.DEPARTEMENT?.ERRORS.MANDATORY;

            } else if (!new RegExp(REGEX.DEPARTEMENT).test(value) && value) {

                invalid = INPUTS.ADRESSE?.DEPARTEMENT?.ERRORS?.INVALID;
            }

            break;

        case INPUTS?.ADRESSE?.CODE_POSTAL?.NAME:

            if (!value && isMandatory) {

                invalid = INPUTS?.ADRESSE?.CODE_POSTAL?.ERRORS.MANDATORY;

            } else if (!new RegExp(REGEX.CODE_POSTAL).test(value) && value) {

                invalid = INPUTS?.ADRESSE?.CODE_POSTAL?.ERRORS.INVALID;
            }

            break;
        default:

            break;
    }

    return { invalid: invalid }
}

export const upperCaseRemoveAccent = (inputString) => {
    let outputString = inputString;
    return outputString ? outputString.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase() : '';
}

export const checkEmail = (mail) => {

    return new RegExp(REGEX?.EMAIL).test(mail?.trim())
}

export const checkTelephone = (telephone, portable = false) => {

    return new RegExp(portable ? REGEX?.TELEPHONE_PORTABLE : REGEX?.TELEPHONE_FIXE).test(telephone)
}

/**
 * Permet de vérifier si un objet js est vide
 * @param objectToEvaluate
 * @returns {boolean} renvoi true si l'objet est vide
 */
export function emptyObject(objectToEvaluate) {

    // console.log("objectToEvaluate === undefined")
    // console.log(objectToEvaluate === undefined)
    //
    // console.log("Object.keys(objectToEvaluate).length === 0")
    // console.log(Object.keys(objectToEvaluate).length === 0)
    //
    // console.log("objectToEvaluate.constructor === Object")
    // console.log(objectToEvaluate.constructor === Object)

    // TODO revoir cette partie
    if (objectToEvaluate === undefined || objectToEvaluate === null) {

        return true

    } else if (Object.keys(objectToEvaluate).length === 0 && objectToEvaluate.constructor === Object) {

        return true

    } else {

        return false
    }

    // return objectToEvaluate === undefined || (Object.keys(objectToEvaluate).length === 0 && objectToEvaluate.constructor === Object)
}

/**
 * Permet de faire un objet à partir d'une liste et de choisir une clé présent dans chaque élement de la liste
 * @param list la liste à itérer
 * @param key la clé à utiliser dans chaque élement de la liste
 * @returns {{}}
 */
export const getObjectWithList = (list, key) => {

    let object = {}

    list.forEach(element => {
        object = {
            ...object,
            [element?.[key]]: element
        }
    })

    return object
}

export const displayJson = (data) => {
    if (typeof data === 'object' && data !== null) {
        if (Array.isArray(data)) {
            return (
                <ul>
                    { data.map((item, index) => (
                        <li key={ index }>
                            { displayJson(item) }
                        </li>
                    )) }
                </ul>
            );
        } else {
            return (
                <div className='display-json'>
                    { Object.entries(data).map(([key, value], index) => (
                        <div key={ index }>
                            <strong>{ key }:</strong> { displayJson(value) }
                        </div>
                    )) }
                </div>
            );
        }
    } else {
        return <span>{ data?.toString() }</span>
    }
}

export function getBooleanValue(input) {

    const type = typeof input;

    if(type === "boolean") {

        return input;
    } else {
        return input === "true" || input === "oui"
    }
}

export const getNewPeriode = () => {
    return {
        nouveau: "O",
        dateIndemnisationDebut: {
            name: "dateIndemnisationDebut",
            value: "",
            invalid: "Champ obligatoire",
        },
        dateIndemnisationFin: {
            name: "dateIndemnisationFin",
            value: "",
            invalid: "Champ obligatoire",
        }
    }
}

export const isFifteenDigits = (value) => {
    const regex = /^\d{15}$/
    return regex.test(value)
}

export const checkInvalidDateEffet = (value, pattern) => {

    let invalid = false

    const PATTERNS = CONF?.PATTERNS
    const YYYY_DASH_MM_DASH_DD = PATTERNS?.YYYY_DASH_MM_DASH_DD
    const DATE_EFFET = CONF?.UI?.FORMULAIRES?.COMMUN_INPUTS?.DATE_EFFET
    const ERRORS_MSG = DATE_EFFET?.ERRORS

    const momentDateEffet = moment(value, pattern ?? YYYY_DASH_MM_DASH_DD)

    if (!value) {

        invalid = ERRORS_MSG?.MANDATORY

    } else if (!momentDateEffet.isValid()) {

        invalid = ERRORS_MSG?.INVALID

    } else if (momentDateEffet.isBefore(moment())) {

        invalid = ERRORS_MSG?.IN_THE_PAST
    }

    return invalid
}

export const checkInvalidNom = (value, key, isMandatory = true) => {

    let invalid = false

    const trimValue = value?.trim()

    if (!trimValue && isMandatory) {

        if (key === CONF?.UI?.FORMULAIRES?.COMMUN_INPUTS?.NOM?.NAME) {

            invalid = CONF?.UI?.FORMULAIRES?.COMMUN_INPUTS?.NOM?.ERRORS?.MANDATORY

        } else {
            invalid = CONF?.UI?.FORMULAIRES?.COMMUN_INPUTS?.PRENOM?.ERRORS?.MANDATORY
        }

    } else if (!new RegExp(/^[A-Za-z\- ']{1,38}$/).test(trimValue) && trimValue) {

        if (key === CONF?.UI?.FORMULAIRES?.COMMUN_INPUTS?.NOM?.NAME) {

            invalid = CONF?.UI?.FORMULAIRES?.COMMUN_INPUTS?.NOM?.ERRORS?.INVALID

        } else {
            invalid = CONF?.UI?.FORMULAIRES?.COMMUN_INPUTS?.PRENOM?.ERRORS?.INVALID
        }
    }

    return invalid
}

export const checkInvalidDateNaissance = (value, mandatory = true) => {

    let invalid = false

    const DATE_NAISSANCE_ERRORS = CONF?.UI?.FORMULAIRES?.COMMUN_INPUTS?.DATE_NAISSANCE?.ERRORS

    if (mandatory && !value) {

        invalid = DATE_NAISSANCE_ERRORS?.MANDATORY

    } else if (value && !moment(value, PATTERNS?.YYYY_DASH_MM_DASH_DD).isValid()) {

        invalid = DATE_NAISSANCE_ERRORS?.INVALID

    } else if (value && moment(value, PATTERNS?.YYYY_DASH_MM_DASH_DD).isAfter(moment())) {

        invalid = DATE_NAISSANCE_ERRORS?.PAST_MANDATORY
    }

    return invalid
}

export const isInteger = (str) => {

    const num = parseInt(str, 10)
    return !isNaN(num) && Number.isInteger(num)
}

export const getUuid = () => {

    return crypto.randomUUID()
}